// app/Pick/TabellaLivePietre.jsx
// Mostra le pick "ottavo posto" di tutti i giocatori della Lega Pietre,
// visibile solo a tappa bloccata/conclusa (stesso principio della tabella
// live principale — non si vedono le pick altrui prima della deadline).

import { useEffect, useState } from 'react'
import { View, Text, StyleSheet, ActivityIndicator } from 'react-native'
import { supabase } from '../../lib/supabase'
import { fonts } from '../../lib/theme'

const P = {
  bg:      '#111111',
  bgCard:  '#1A1A1A',
  bgTile:  '#222222',
  border:  '#333333',
  text:    '#FFFFFF',
  muted:   '#888888',
  success: '#4CAF50',
  error:   '#E53935',
}

export default function TabellaLivePietre({ idStage }) {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!idStage) return
    setLoading(true)
    supabase.rpc('fn_pietre_pick_stage_all', { p_id_stage: idStage })
      .then(({ data }) => {
        setRows(data ?? [])
        setLoading(false)
      })
  }, [idStage])

  if (loading) {
    return (
      <View style={styles.wrapper}>
        <ActivityIndicator color={P.muted} style={{ marginVertical: 16 }} />
      </View>
    )
  }

  if (rows.length === 0) return null

  return (
    <View style={styles.wrapper}>
      <View style={styles.header}>
        <Text style={styles.headerTitle}>PICK DI TUTTI · OTTAVO POSTO</Text>
      </View>
      <View style={styles.body}>
        {rows.map((r, i) => (
          <View key={r.id_user} style={[styles.row, i % 2 === 1 && styles.rowAlt]}>
            <Text style={styles.name} numberOfLines={1}>{r.display_name}</Text>
            <Text style={styles.rider} numberOfLines={1}>{r.rider_name}</Text>
            <View style={styles.esito}>
              {r.points == null ? (
                <Text style={styles.pending}>—</Text>
              ) : r.is_correct ? (
                <Text style={[styles.esitoText, { color: P.success }]}>✓ +{r.points}</Text>
              ) : (
                <Text style={[styles.esitoText, { color: P.error }]}>✗</Text>
              )}
            </View>
          </View>
        ))}
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    marginTop: 12,
    marginHorizontal: 8,
    borderRadius: 4,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: P.border,
  },
  header: {
    backgroundColor: P.bg,
    paddingHorizontal: 14,
    paddingVertical: 10,
  },
  headerTitle: {
    fontSize: 11,
    fontFamily: fonts.condensedBold,
    color: P.muted,
    letterSpacing: 2,
    textTransform: 'uppercase',
  },
  body: {
    backgroundColor: P.bgCard,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 9,
    paddingHorizontal: 14,
    gap: 8,
  },
  rowAlt: {
    backgroundColor: P.bgTile,
  },
  name: {
    flex: 1,
    fontSize: 12,
    fontFamily: fonts.condensedBold,
    color: P.text,
    textTransform: 'uppercase' },
  rider: {
    flex: 1,
    fontSize: 12,
    color: P.muted,
    textAlign: 'right',
  },
  esito: {
    minWidth: 44,
    alignItems: 'flex-end',
  },
  esitoText: {
    fontSize: 11,
    fontFamily: fonts.condensedBold },
  pending: {
    fontSize: 12,
    color: P.muted,
  },
})